import { render } from "./FileComponent.vue?vue&type=template&id=7c9a01bf&scoped=true"
import script from "./FileComponent.vue?vue&type=script&lang=js"
export * from "./FileComponent.vue?vue&type=script&lang=js"

import "./FileComponent.vue?vue&type=style&index=0&id=7c9a01bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9a01bf"]])

export default __exports__